import { render, staticRenderFns } from "./DoctorServicePrices.vue?vue&type=template&id=7f95ea17&"
import script from "./DoctorServicePrices.vue?vue&type=script&lang=js&"
export * from "./DoctorServicePrices.vue?vue&type=script&lang=js&"
import style0 from "./DoctorServicePrices.vue?vue&type=style&index=0&id=7f95ea17&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f95ea17')) {
      api.createRecord('7f95ea17', component.options)
    } else {
      api.reload('7f95ea17', component.options)
    }
    module.hot.accept("./DoctorServicePrices.vue?vue&type=template&id=7f95ea17&", function () {
      api.rerender('7f95ea17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorServicePrices/DoctorServicePrices.vue"
export default component.exports